"use client";

import { getRoutes } from "@lib/routes";

import { useLanguage } from "./useLanguage";

export function useRoutes() {
  const language = useLanguage();

  const routes = getRoutes(language);

  return routes;
};
